<ui-page-header>Schnellerfassung</ui-page-header>
<div class="content-wrapper">
  <div class="content-left">
    <ui-quick-order-add [(activeTab)]="activeTab" (productsAdded)="onProductsAdded($event)"></ui-quick-order-add>
  </div>
  <div class="content-main">
    @if (!shoppingListState.isLoading()) {
      <ui-quick-order-product-list
        uiProductTrackingList="schnellerfassung"
        (tabSelected)="activeTab.set($event)"
        [productsToSelect]="productsToSelect()"
        (productsToSelectChange)="productsToSelect.set($event)"
        [missingProducts]="missingProducts()"
      ></ui-quick-order-product-list>
    }
  </div>
</div>
